import accountService from "../services/AccountService";
import ModuleService from "../services/ModuleService";
import { UserRoles } from "../utils/constants";

export default {
  login({ commit }, { Username, Password }) {
    return new Promise((resolve, reject) => {
      let body = { Username, Password };
      accountService
        .login(body)
        .then((response) => {
          const isChangePasswordRequired = response?.data?.ChangePassword || false;

          const data = response?.data;

          commit("updateUserToken", {
            access: data?.HmsToken,
            refresh: data?.HmsToken,
          });

          const allowUserFunction = () => {
            commit("updateUserInfo", data);
          };

          if (isChangePasswordRequired) {
            return resolve({
              ...response,
              isChangePasswordRequired,
              allowUserFunction,
            });
          }

          allowUserFunction();
          return resolve(response);
        })
        .catch((err) => {
          window.showError(err);
          return reject(err);
        });
    });
  },

  logout({ commit }) {
    accountService
      .logout()
      .then((res) => {
        console.log("Logout res >> ", res);
      })
      .catch((err) => {
        console.log("Logout err >> ", err);
      })
      .then(() => {
        commit("authLogout", {});
      });
  },

  getMenuData({ commit }) {
    return
    ModuleService.getMyPages()
      .then((res) => {
        console.log("res navigate : ", res.data);
        let items = [];
        res.data.forEach((element) => {
          let obj = {};
          if (element.Type == "static") {
            //Sabit sayfalar
            obj = {
              label: element.Name,
              to: "/home/" + element.Route,
              icon: element.Icon,
            };
          } else {
            //Modül sayfalar , type = 'custom'
            obj = {
              label: element.Name,
              to: "/home/moduls/" + element.Id,
              icon: element.Icon,
            };
          }
          items.push(obj);
        });
        commit("setMenuItems", items);
      })
      .catch((err) => {
        window.showError(err);
      })
      .then(() => {});
  },
};
